import { Copyright } from './ui/copyright';

export function Footer() {
  return (
    <footer className="py-4 text-center">
      <Copyright />
    </footer>
  );
}
